// Le journal des nouveautés, **tel qu'il est écrit** — jamais une copie.
//
// C'est la décision de l'utilisateur : *une seule version à maintenir*.
// `synkara/CHANGELOG.md` est le texte que l'on écrit, celui qu'une lettre reprend,
// et celui que l'écran affiche. Il entre ici **à la construction** (`?raw`), et non
// par le réseau : l'écran doit s'ouvrir hors ligne comme le reste du site, et un
// texte téléchargé serait la première chose à manquer.
//
// Ce fichier ne fait que ça — le découpage vit dans [`news.ts`](news.ts), qui reste
// pur et donc mesurable.
import raw from '../../CHANGELOG.md?raw';
import { parseReleases, versionOf, type Release } from './news.js';

/** Les versions, de la plus récente à la plus ancienne — l'ordre du fichier. */
export const releases: readonly Release[] = parseReleases(raw);

/** Le numéro affiché dans le menu du compte. */
export const VERSION: string = versionOf(releases);
